import './coordination-actions-menu/coordination-actions-menu.component';

import './coordination-detailed-view/coordination-detailed-view.component';
import './coordination-detailed-view/coordination-detailed-view.scss';

import './coordinations-list/coordinations-list.component';
import './coordinations-list/coordinations-list.scss';

import './coordinations-table/coordinations-table.component';
import './coordinations-table/coordinations-table.scss';

import './create-new-coordination/create-new-coordination.component';
import './create-new-coordination/create-new-coordination.scss';

import './edit-coordination/edit-coordination.component';
import './edit-coordination/edit-coordination.scss';

import './services-actions-menu/services-actions-menu.component';

import './services-table/services-table.component';
import './services-table/services-table.scss';

import './single-service-actions-menu/single-service-actions-menu.component';
